import React, { useEffect, useState } from 'react';

const LazyRouteLoaderComponent: React.FC = () => {
    const [showInner, setShowInner] = useState(false);

    useEffect(() => {
        const timer = setTimeout(() => {
            setShowInner(true);
        }, 500);

        return () => clearTimeout(timer);
    }, []);

    return (
        <div className='page-loader-container show fade'>
            {showInner && (
                <div>
                    <img src="/images/logo-sm.svg" alt='logo' />
                    <div className="spinner-loader"></div>
                </div>
            )}
        </div>
    );
};

export default LazyRouteLoaderComponent;
